import { isEnabled } from "utils/featureFlags";

import * as projectReducer from "containers/Project/reducer";
import * as monitoringReducer from "containers/Monitoring/reducer";

import * as MonitoringAPI from "api/MonitoringAPI";

const UPDATE_FIELD = "mobileMonitor/UPDATE_FIELD";

const initialState = {
  displayType: "weekly",
  viewingMobile: false,
  loadStatus: undefined
};

function MobileMonitorReducer(state = initialState, action) {
  switch (action.type) {
    case UPDATE_FIELD:
      return {
        ...state,
        [action.key]: action.data
      };
    default:
      return state;
  }
}
/* Selectors */
export function getIsMonitorMobile() {
  return isEnabled("monitor-mobile");
}

export function getMobileMonitor(state) {
  return state.mobileMonitor;
}

export function getDisplayType(state) {
  return getMobileMonitor(state).displayType;
}

export function getViewingMobile(state) {
  return getMobileMonitor(state).viewingMobile;
}

export function getLoadStatus(state) {
  return getMobileMonitor(state).loadStatus;
}

/* Actions */

export function updateDisplayType(value) {
  return { type: UPDATE_FIELD, data: value, key: "displayType" };
}

export function updateViewingMobile(value) {
  return { type: UPDATE_FIELD, data: value, key: "viewingMobile" };
}

export function updateLoadStatus(value) {
  return { type: UPDATE_FIELD, data: value, key: "loadStatus" };
}

export function detectIfMobile() {
  //test nav userAgent, navVendor, and window opera with same regex. If all fail, return false\
  let regex1 =
    /(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i;
  let regex2 =
    /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i;

  if (navigator.userAgent && (regex1.test(navigator.userAgent) || regex2.test(navigator.userAgent.substr(0, 4)))) {
    return true;
  }

  if (navigator.vendor && (regex1.test(navigator.vendor) || regex2.test(navigator.vendor.substr(0, 4)))) {
    return true;
  }

  if (window.opera && (regex1.test(window.opera) || regex2.test(window.opera.substr(0, 4)))) {
    return true;
  }

  return false;
}

export function getMonitorWarnings(state, projectIDs) {
  let warnings = [];
  for (let projectId of projectIDs) {
    const overallSegmentId = projectReducer.getOverallSegmentId(state, projectId);
    warnings.push(monitoringReducer.getMonitorSegmentWarnings(state, projectId, overallSegmentId));
  }

  return warnings;
}

export function getMonitorProfits(state, projectIDs) {
  let profits = [];
  for (let projectId of projectIDs) {
    const overallSegmentId = projectReducer.getOverallSegmentId(state, projectId);
    profits.push(monitoringReducer.getLatestProfitBySegment(state, projectId, overallSegmentId));
  }

  return profits;
}

export function loadMonitorData() {
  return (dispatch, getState) => {
    if (getLoadStatus(getState()) != "loaded") {
      dispatch(updateLoadStatus("loading"));
      dispatch(projectReducer.fetchProjects()).then(() => {
        MonitoringAPI.getMonitoringData().then((response) => {
          const projectSegmentMontiors = response;

          if (projectSegmentMontiors.length == 0) {
            return dispatch(updateLoadStatus("loaded"));
          }

          const promises = projectSegmentMontiors.map(
            // for each project, pull the monitoring data
            // wait for the monitoring data
            // if no data recieved, continue
            // else proceed with current grab procedures
            (project, i) => {
              return setTimeout(() => {
                dispatch(projectReducer.fetchProject(project.project_id))
                  .then(
                    //before dispatch, i should check to see if the fetchProject contained any segments
                    () => {
                      dispatch(projectReducer.loadJobsFromProject(project.project_id));
                    }
                  )
                  .then(() => {
                    dispatch(monitoringReducer.init(project.project_id));
                  })
                  .then(() => {
                    if (i == projectSegmentMontiors.length - 1) {
                      //faulty assertion, its possible that certain jobs no longer exist
                      dispatch(updateLoadStatus("loaded"));
                    }
                  });
              }, 250 * i);
            }
          );
          return Promise.all(promises);
        });
      });
    }
  };
}

export function getMontiors(projectIDs, warningsGroup) {
  return (dispatch, getState) => {
    let warningStuff = [];
    for (let idx in warningsGroup) {
      if (warningsGroup[idx]) {
        warningStuff.push(monitoringReducer.getMonitor(getState(), projectIDs[idx]));
      }
    }
    return warningStuff;
  };
}

/* Methods */

export default MobileMonitorReducer;
